/**
 * Containers & sectiosn for the detailed view
 */
import styled from 'styled-components';

const Container = styled.div`
    color: ${({ theme }) => theme.text};
    font-family: 'Atlas Grotesk Medium', sans-serif;
    background-color: #f3f3f3;
    border-top: 1px solid #aaaaaa;
`;

const Body = styled.div`
    display: flex;
    align-items: center;
`;

const Section = styled.div`
    flex: 1 1 0%;
    width: 0;
`;

export { Container, Body, Section };
